/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const errorResponseExtraDataSchema = z.object({}).catchall(z.any()).nullable();
